import React, { useId } from 'react';
import LiveRegion from '../../../atoms/LiveRegion/LiveRegion';
import { useFormContext } from '../../../molecules/Form';
import { Namespace } from '../../../../translation/namespace';
import FormsRow from '../../../molecules/Form/components/FormsRow/FormsRow';
import FormInput from '../../../molecules/Form/components/FormInput/FormInput';
import { FormSubmitButton } from '../../../molecules/Form/components/FormSubmitButton/FormSubmitButton';
import { RequiredHelpPhrase } from '../../../../_lib/Form2';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

export function ExternalLinkDetailsFormTemplate() {
  const { inputs, onChange, submitActionEnabled, getStatus } = useFormContext();
  const { t } = useSonTranslation('ExternalLinkDetails');

  const uniqueId = useId();

  return (
    <>
      <RequiredHelpPhrase />
      <FormsRow>
        <FormInput
          id={`${inputs.url.name}-${uniqueId}`}
          value={inputs.url.value}
          type={inputs.url.type}
          name={inputs.url.name}
          required={inputs.url.required}
          labelTitle={t('inputs.url.label')}
          maxLength={inputs.url.constraints?.maxLength}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.name, event.target.value)}
        />
      </FormsRow>
      <FormsRow>
        <FormInput
          id={`${inputs.name.name}-${uniqueId}`}
          value={inputs.name.value}
          name={inputs.name.name}
          required={inputs.name.required}
          labelTitle={t('inputs.name.label')}
          labelHelpText={t('inputs.name.helpText')}
          maxLength={inputs.name.constraints?.maxLength}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.name, event.target.value)}
          pattern={inputs?.name?.constraints?.pattern}
        />
      </FormsRow>
      <FormSubmitButton buttonLabel={t(`${Namespace.phrases}:saveChanges`)} enabled={submitActionEnabled()} />
      <LiveRegion htmlTag="div" invisible={false} ariaAtomic ariaLive="polite">
        {getStatus()}
      </LiveRegion>
    </>
  );
}
